export const closeLoadingScreen = () => {
    // Close loading indicator started in index.html
    const loadingElement = document.getElementById("loading");
    if (loadingElement) {
        //console.debug(`Hiding loading element...`);
        loadingElement.style.display = "none";
    }
}

export const openLoadingScreen = () => {
    // Close loading indicator started in index.html
    const loadingElement = document.getElementById("loading");
    if (loadingElement) {
        //console.debug(`Hiding loading element...`);
        loadingElement.style.display = "block";
    }
}